import io, { Socket } from 'socket.io-client'

let socket: Socket

const emitEvent = (eventType: string, payload: any, callback?: (value: void) => void) => {
	if (callback) {
		socket.emit(eventType, { ...payload }, callback)
	} else {
		socket.emit(eventType, { ...payload })
	}
}

const connect = (path: string, query: any) => {
	socket = io(path, { forceNew: true, query, transports: ['websocket', 'polling'] })
}

const disconnect = () => {
	if (socket) {
		socket.disconnect()
	}
}

const reconnect = () => {
	if (socket) {
		socket.connect()
	}
}

const on = (eventType: string, callback: (data?: any) => void) => {
	socket.on(eventType, callback)
}

const emit = (eventType: string, payload: any = {}, withCallback = false) => {
	return new Promise((resolve: (value: void) => void) => {
		if (withCallback) {
			// If the message is expecting a response, we pass the promise resolve
			// method that will be executed as the callback por the socket message
			emitEvent(eventType, payload, resolve)
		} else {
			emitEvent(eventType, payload)
			// if the message is not expecting a response we resolve immediately
			resolve()
		}
	})
}

export default {
	connect,
	disconnect,
	reconnect,
	on,
	emit,
}
